module.exports = __webpack_public_path__ + "img/cortepelo.fc2a7cf9.jpg";